import { render, staticRenderFns } from "./WhatsAppSingleProduct.vue?vue&type=template&id=e234b586&"
import script from "./WhatsAppSingleProduct.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSingleProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports